/* global __app_id */
// Firebase Configuration - Centralized
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
    apiKey: "AIzaSyBt-6AMPHy8XU0f3kW5wbA7g1_Pj3Qr76k",
    authDomain: "cosmic-compass-ec46c.firebaseapp.com",
    projectId: "cosmic-compass-ec46c",
    storageBucket: "cosmic-compass-ec46c.firebasestorage.app",
    messagingSenderId: "1093814318479",
    appId: "1:1093814318479:web:82899b82515ce0a36487fa",
    measurementId: "G-W7F240XR6G"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const functions = getFunctions(app);

export const appId = typeof __app_id !== 'undefined' ? __app_id : 'default-cosmic-compass-app';
